const API_URL = '/api';

export interface SupportTicket {
    id: number;
    status: 'open' | 'in_progress' | 'waiting_customer' | 'resolved' | 'closed';
    createdAt: string;
    updatedAt: string;
    resolvedAt: string | null;
}

export interface SupportMessage {
    id: number;
    ticketId: number;
    content: string;
    isStaffMessage: boolean;
    createdAt: string;
}

export const getTickets = async (): Promise<SupportTicket[]> => {
    const response = await fetch(`${API_URL}/support/ticket`, {
        credentials: 'include'
    });
    if (!response.ok) throw new Error('Failed to fetch tickets');
    return response.json();
};

export const createTicket = async (message: string): Promise<Response> => {
    return fetch(`${API_URL}/support/ticket`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ message })
    });
};

export const getMessages = async (ticketId: number): Promise<SupportMessage[]> => {
    const response = await fetch(`${API_URL}/support/message?ticket=${ticketId}`, {
        credentials: 'include'
    });
    if (!response.ok) throw new Error('Failed to fetch messages');
    return response.json();
};

export const sendMessage = async (ticketId: number, content: string): Promise<void> => {
    const response = await fetch(`${API_URL}/support/message`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ 
            ticket: ticketId,
            content 
        })
    });
    if (!response.ok) throw new Error('Failed to send message');
}; 

export const closeTicket = async (ticketId: number): Promise<void> => {
    const response = await fetch(`${API_URL}/support/ticket?ticket=${ticketId}`, {
        method: 'DELETE',
        credentials: 'include'
    });
    if (!response.ok) throw new Error('Failed to close ticket');
};